import React from 'react';
import { connect } from 'react-redux';
import { NTabs } from '@fttb/common';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getActiveModalTab, getModalTabs } from "../../../../store/blocks/devices/modalSelectors";
import { setActiveTab } from "../../../../store/blocks/devices/slice";
import { TabsContext } from "./components/context";
import { DeviceTabContent } from "./components/DeviceTabContent";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _DeviceModalTabs = function _DeviceModalTabs(_ref) {
  var children = _ref.children,
    onChange = _ref.onChange,
    selectedTab = _ref.selectedTab,
    tabs = _ref.tabs;
  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: selectedTab
  }, /*#__PURE__*/React.createElement(NTabs, {
    className: cx('tabs'),
    noWrap: true,
    onChange: onChange,
    selectedTab: selectedTab,
    tabs: tabs,
    variant: "tertiary",
    "data-t-id": "components-DeviceModalTabs"
  }), children);
};
_DeviceModalTabs.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  onChange: PropTypes.func,
  selectedTab: PropTypes.number,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string
  }))
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedTab: getActiveModalTab(state),
    tabs: getModalTabs(state)
  };
};
var mapDispatchToProps = {
  onChange: setActiveTab
};
export var DeviceModalTabs = connect(mapStateToProps, mapDispatchToProps)(_DeviceModalTabs);
DeviceModalTabs.Tab = DeviceTabContent;